export default {
  ROOT: "MenuBar",
  SIDEBAR_TRIGGER_LABEL: "MenuBarSidebarTriggerLabel"
};
